<template>
  <div class="contacts-page">
    <page-head-static-component
      :bgImg="require('@/assets/img/contacts_bg.png')"
      textColor="#FFFFFF"
      :ttl="'Контакты'"
    ></page-head-static-component>

    <block-container-component bgC="#F3F3F3">
      <template slot="content">
        <contacts-component></contacts-component>
      </template>
    </block-container-component>
  </div>
</template>

<script>
// @ is an alias to /src
export default {};
</script>

<style lang="scss" scoped>
.home {
  background-color: $bg1Color;
}
</style>
